import { useQuery } from '@tanstack/react-query';
import { endpoints } from '../api/endpoints';
import { useAuth } from '../store/auth';

/**
 * The branches this user may act at. A cashier scoped to one showroom should
 * never be shown a branch picker at all, so the hook reports that too.
 */
export function useBranches() {
  const scoped = useAuth((s) => s.session?.branchIds ?? []);
  const query = useQuery({ queryKey: ['branches'], queryFn: () => endpoints.organisation.branches() });

  const all = query.data?.data ?? [];
  const visible = scoped.length === 0 ? all : all.filter((b) => scoped.includes(b.id));

  return {
    ...query,
    branches: visible,
    defaultBranchId: visible[0]?.id ?? null,
    mustChoose: visible.length > 1,
  };
}
